<template>
  <dl>
    <dt @click="toggleFilter()" :class="filterOpen ? '_visible' : ''">{{ filter.label }}</dt>
    <dd v-show="filterOpen">
      <ol :class="{'_columns' : splitColumns}">
        <template v-for="(option, index) in filterOptions">
          <li v-show="filterIsVisibleCheck(index)" @click="$store.dispatch(`${dataSource}/toggleFilter`, { filter: filter, option: option })">
            <label :class="{ '_active': option.active }">
              <span class="_checkbox"></span>
              {{ option.label }}
              <span class="_count" v-if="!splitColumns">({{ option.result_count }})</span>
            </label>
          </li>
        </template>
      </ol>
      <a v-if="filterOptions.length > filtersToShow" href="#" @click.prevent.stop="toggleFilterValueCollapse()" class="_button _small">
        <span v-if="filterCollapsed">{{ $t('Show more') }}</span>
        <span v-else>{{ $t('Show less') }}</span>
      </a>
    </dd>
  </dl>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';

  @Component({
    name: 'attribute-filter'
  })

  export default class extends Vue {
    @Prop(String) readonly dataSource: string;
    @Prop(Object) readonly filter!: object;

    private splitColumns: boolean = false;
    readonly filtersToShowDefault: number = 5;
    readonly filtersToShowColumns: number = 10;
    readonly smallBreakpoint: number = 768;
    private filterCollapsed: boolean = false;
    private filterOpen: boolean = false;

    // Props are not available in class field initializers with the v5 build
    // chain (useDefineForClassFields); initialize from props in created().
    private created(): void {
      const filter = this.filter || {};
      const options = Array.isArray(filter['options']) ? filter['options'] : [];

      this.splitColumns = filter['layout'] === '2columns';
      this.filterCollapsed = options.length > this.filtersToShow;
      this.filterOpen = window.outerWidth >= this.smallBreakpoint;
    }

    private get filtersToShow(): number {
      return this.splitColumns ? this.filtersToShowColumns : this.filtersToShowDefault;
    }

    private get filterOptions(): Array<object> {
      return Array.isArray(this.filter?.['options']) ? this.filter['options'] : [];
    }

    toggleFilterValueCollapse(): void {
      this.filterCollapsed = !this.filterCollapsed;
    }

    filterIsVisibleCheck(index): boolean {
      return this.filterCollapsed ? index < this.filtersToShow : true;
    }

    toggleFilter(): void {
      this.filterOpen = !this.filterOpen;
    }
  }
</script>
